import { render, staticRenderFns } from "./MapMarkerHistoricalSiteIcon.vue?vue&type=template&id=3bee8715&"
import script from "./MapMarkerHistoricalSiteIcon.vue?vue&type=script&lang=js&"
export * from "./MapMarkerHistoricalSiteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports